import { Map } from 'immutable';
import * as switcherConfig from '../optionSets/switchers';

export default function switchers(state = new Map(), action) {
    switch (action.type) {
        case 'SET_SWITCHER_VALUE':
            return state.mergeDeep({
                [action.name]: {
                    value: action.value
                }
            });
        case 'FILTER_CLEAR':
            return state.mergeDeep({
                [switcherConfig.SIRE_LINE.name]: {
                    value: switcherConfig.SIRE_LINE.value
                },
                [switcherConfig.STALLION.name]: {
                    value: switcherConfig.STALLION.value
                }
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/client/reducers/switchers.js